export const generatePathForFileUpload = (orderId: string, uuid: string) => {
  if (!orderId || !uuid || orderId.includes("..") || uuid.includes("..")) {
    throw new Error("Invalid path parameters");
  }
  return `onco_emr/${orderId}/clinical_attachment/${uuid}.pdf`;
};
